import * as Normalize from '../normalize';
import * as Types from './types';
import * as PanelNormalize from '../panel/normalize';
import {omit as _omit} from 'lodash';

const omit = _omit as <T extends object, K extends keyof T>(
  obj: T,
  ...keys: K[]
) => Omit<T, K>;

export const normalize = Normalize.normFn<
  Types.PanelBankSectionConfigObjSchema
>('panel-bank-section-config', (whole, ctx) => {
  return {
    ...omit(whole, 'panels'),
    panelRefs:
      whole.panels != null
        ? whole.panels.map(panel => PanelNormalize.normalize(panel, ctx))
        : [],
  };
});

export const denormalize = Normalize.denormFn<
  Types.PanelBankSectionConfigObjSchema
>((part, ctx) => {
  return {
    ...omit(part, 'panelRefs'),
    panels:
      part.panelRefs != null
        ? part.panelRefs.map(ref => PanelNormalize.denormalize(ref, ctx))
        : [],
  };
});
